import { render, staticRenderFns } from "./SummaryItems.vue?vue&type=template&id=14a802c2&"
import script from "./SummaryItems.vue?vue&type=script&lang=ts&"
export * from "./SummaryItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports